import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Constants } from 'src/app/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manual-usuario',
  templateUrl: './manual-usuario.component.html',
  styleUrls: ['./manual-usuario.component.css']
})
export class ManualUsuarioComponent implements OnInit {

  titulo = Constants.MANUAL_USUARIO;
  manualUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url =
      `${environment.apiUrl}/Administracion/InformacionGeneral/GetManualUsuario#view=FitH`;

    this.manualUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}